<template>
    <client-page>
        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="client-title--xxxl">오시는 길</h2>
                    </div>
                    <v-row>
                        <v-col cols="12">
                            <!-- <v-img src="/images/about/location/map.jpg" class="border-radius-16 location" /> -->
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3160.952308677184!2d127.03954497640714!3d37.60328142201932!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357cbb7e79c5198b%3A0x889f6e2ee3aeb6ce!2z7ISc7Jq47Yq567OE7IucIOyEseu2geq1rCDtmZTrnpHroZwxMeq4uCAyNg!5e0!3m2!1sko!2skr!4v1743994301552!5m2!1sko!2skr"
                                width="100%"
                                style="border: 0; aspect-ratio: 1200 / 678"
                                allowfullscreen=""
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                                class="border-radius-16"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                            <div class="px-8 py-24">
                                <v-row v-for="(item, index) in items" :key="index" no-gutters class="page-text page-text--lg row--xxs">
                                    <v-col cols="auto">
                                        <v-sheet width="120" class="primary--text">
                                            {{ item.name }}
                                        </v-sheet>
                                    </v-col>
                                    <v-col>
                                        {{ item.text }}
                                    </v-col>
                                </v-row>
                            </div>
                            <v-divider />
                        </v-col>
                    </v-row>
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";

export default {
    components: {
        ClientPage,
    },
    data() {
        return {
            items: [
                {
                    name: "주소",
                    text: "서울특별시 성북구 화랑로11길 26 갑을명가 2층 215호 위드캔복지재단",
                },
                {
                    name: "대표전화",
                    text: "02-2057-2296",
                },
                {
                    name: "팩스번호",
                    text: "02-2057-2295",
                },
                {
                    name: "오시는 길",
                    text: "월곡역(6호선) 3번 출구(도보 5분)",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
}
</style>